<template>
  <div class="organization">
    <!-- 组织 -->
    <div class="organization-left">
      <div class="left-button">组织架构</div>
      <div class="trees-cont-scroll">
        <Tree class="trees" :data="data" @on-select-change="handleChange"></Tree>
      </div>

    </div>
    <div class="organization-right">
      <OrganizationContentOne @getoneTotree="getoneTotree" ref="OrganizationContentOne" @gettrees="gettrees" :toChildId="toChildId"></OrganizationContentOne>
    </div>
    <div style="clear:both;"></div>
  </div>
</template>
<script>
import Vue from 'vue'
import { getStructureTree } from '../servers/api'
import OrganizationContentOne from './organizationContentOne';
export default {
  name: 'organization',
  data () {
    return {
      data: [],
      treeData: [],
      toChildId: 1,//传给子组件的id
    }
  },
  created () {
    this.list = []; // 选择的数据
    this.getTree(1, 1)
  },
  components: {
    OrganizationContentOne
  },
  methods: {
    gettrees (res, parentid, id) {//传过来添加或者修改部门后 通知
      if (parentid) {
        this.getTree(parentid, 1)
      } else {
        this.getTree();
      }
    },
    setPid (item, parentid) {//递归找出点击的项
      let that = this;
      if (item.children && item.children.length > 0) {
        if (item.id == parentid) {
          let list = [];
          list.push(item);
          this.handleChange(list);
          return
        } else {
          item.children.map(e => {
            if (e.id == parentid) {
              let list = [];
              list.push(e)
              this.handleChange(list)
              return
            } else {
              this.setPid(e, parentid)
            }
          })
        }
      } else {
        if (item.id == parentid) {
          let list = [];
          list.push(item)
          this.handleChange(list)
          return
        }
      }
    },
    getTree (parentid, index) {//获取树形  
      let params = {
        parentId: parentid || ''
      }
      getStructureTree(params).then(res => {
        if (res.data.code == 1) {
          this.data = res.data.data || [];
          if (index) {
            this.setPid(this.data[0], parentid);
          }
        } else {
          this.ishowtitle = true;
        }
      })
    },
    getoneTotree (e) {//子组件点击下级部门列表
      let arr = [];
      arr.push(e)
      this.getTree(arr[0].id, 1)
    },
    handleChange (e, index) {
      if (e.length > 0) {
        Vue.set(e[0], 'selected', true)
        if (e[0].expand) {
          Vue.set(e[0], 'expand', false)
        }
        e[0].selected = true;
        e[0].expand = !e[0].expand;
        this.treeData = e;
      } else {
        e = this.treeData;
        if (e[0].expand) {
          Vue.set(e[0], 'expand', false)
        }
        Vue.set(e[0], 'selected', true)
        e[0].selected = true;
        e[0].expand = !e[0].expand;
      };
      this.toChildId = e[0].id;
      if (this.toChildId !== -1) {
        this.$refs.OrganizationContentOne.getSubordinateLists(e[0].id, 1)
        this.$refs.OrganizationContentOne.getUserListByStructureIds(e[0].id, 1)
      } else {
        this.$refs.OrganizationContentOne.lizhiPeople(1)
      }
    },

  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.trees-cont-scroll {
  padding-top: 15px;
  height: calc(100% - 30px);
  padding-bottom: 20px;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
}
.organization {
  width: 100%;
  height: 100%;
  font-family: SimHei;
  font-size: 13px;
  color: #7f7f7f;
  .organization-left {
    padding: 15px;
    width: 240px;
    overflow: hidden;
    border-right: 1px solid #d7d7d7;
    height: calc(100% - 100px);
    position: absolute;
    .left-button {
      width: 210px;
      border: 1px solid #53cac3;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-top-left-radius: 11px;
      border-top-right-radius: 11px;
    }
  }
  .organization-right {
    height: 100%;
    padding-left: 240px;
  }
  .ivu-tree /deep/,
  .ivu-tree /deep/ .ivu-tree-title {
    color: #7f7f7f;
    font-weight: 600;
    font-size: 13px;
  }

  .ivu-tree /deep/ .ivu-tree-title-selected {
    background: none;
    color: #53cac3;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/shezhi/organization.vue